import axios from "../../lib/axios";
import * as types from "src/types/facility";
import { ApiResponse } from "src/types/common";

export const getAllfacilityRequest = (): Promise<ApiResponse<types.FacilityRequest[]>> =>
    axios.get("/api/v1/facility/getAllfacilityRequest").then(res => res.data);

export const getFacilityRequestById = (facilityId: number): Promise<ApiResponse<types.FacilityRequest>> =>
    axios.get("/api/v1/facility/getFacilityRequestById", { params: { FacilityRequestId: facilityId } }).then(res => res.data);

export const getUserFacilityHistory = () => axios.get("/api/v1/facility/getClosedFacilityRequestHistory");

export const deleteFacilityInquiry = (facilityId: number): Promise<ApiResponse> =>
    axios.delete(`/api/v1/facility/deleteFacilityInquiry?facilityRequestId=${facilityId}`);

export const getFacilityRequestFlow = (facilityId: number): Promise<ApiResponse<types.FacilityRequestFlow[]>> =>
    axios.get("/api/v1/facility/getFacilityRequestFlow", { params: { ObjectId: facilityId } }).then(res => res.data);

export const selectProvider = (id: number): Promise<ApiResponse> =>
    axios.post("/api/v1/facility/facilityRequest", { id }).then(res => res.data);

export const getBankInquiry = (facilityRequestId: number): Promise<ApiResponse<types.BankInquiry>> =>
    axios.put(`/api/v1/facility/getBankInquiry?facilityRequestId=${facilityRequestId}`).then(res => res.data);

export const getFacilityUserInfo = (): Promise<ApiResponse<types.FacilityUserInfo>> =>
    axios.get("/api/v1/facility/getFacilityUserInfo").then(res => res.data);

export const inquiryPostalCode = (params): Promise<ApiResponse<any>> =>
    axios.get("/api/v1/facility/inquiryPostalCode", params).then(res => res.data);

export const inquiryUserCard = (params): Promise<ApiResponse<any>> =>
    axios.get("/api/v1/facility/inquiryUserCard", params).then(res => res.data);

export const registerFacilityUserInfo = (payload): Promise<ApiResponse<any>> =>
    axios.put("/api/v1/facility/registerFacilityUserInfo", payload).then(res => res.data);

export const getDocumentTypeBasedOnCareer = (careerStatus: number): Promise<ApiResponse<types.DocumentTypeBasedOnCareer[]>> =>
    axios.post("/api/v1/facility/getDocumentTypeBasedOnCareer", { careerStatus }).then(res => res.data);

export const setEducationAndCareerInformation = (data): Promise<ApiResponse<any>> =>
    axios.post("/api/v1/facility/setEducationAndCareerInformation", data).then(res => res.data);

export const getJetClubPlanList = (): Promise<ApiResponse<types.JetClubPlanList[]>> =>
    axios.get("/api/v1/facility/getJetClubPlanList").then(res => res.data);

export const assignCredit = (facilityId: number): Promise<ApiResponse<any>> =>
    axios.put("/api/v1/facility/assignCredit");

export const uploadChequeImage = (payload): Promise<ApiResponse<any>> =>
    axios.post("/api/v1/facility/uploadChequeImage", payload).then(res => res.data);